import React from "react";

const thumbnailWidth = 300;
const thumbnailHeight = 300;

/* eslint-disable no-param-reassign */
const parallelogramData = [
  {
    src: "images/examples/parallelogram_b1.png",
    thumbnail: "images/examples/parallelogram_b1.png",
    itemType: "parallelogram",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: false,
      isBlue: true,
      isRotated: true,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/examples/parallelogram_g1.png",
    thumbnail: "images/examples/parallelogram_g1.png",
    itemType: "parallelogram",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: true,
      isBlue: false,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/examples/parallelogram_r1.png",
    thumbnail: "images/examples/parallelogram_r1.png",
    itemType: "parallelogram",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: true,
      isGreen: false,
      isBlue: false,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/examples/parallelogram_r2.png",
    thumbnail: "images/examples/parallelogram_r2.png",
    itemType: "parallelogram",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: true,
      isGreen: false,
      isBlue: false,
      isRotated: false,
      isThin: true,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/examples/parallelogram_r3.png",
    thumbnail: "images/examples/parallelogram_r3.png",
    itemType: "parallelogram",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: true,
      isGreen: false,
      isBlue: false,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/examples/rectangle_b1.png",
    thumbnail: "images/examples/rectangle_b1.png",
    itemType: "rectangle",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: false,
      isBlue: true,
      isRotated: false,
      isThin: true,
      hasEveryRightAngles: true,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/examples/rectangle_b2.png",
    thumbnail: "images/examples/rectangle_b2.png",
    itemType: "rectangle",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: false,
      isBlue: true,
      isRotated: true,
      isThin: false,
      hasEveryRightAngles: true,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/examples/rectangle_g1.png",
    thumbnail: "images/examples/rectangle_g1.png",
    itemType: "rectangle",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: true,
      isBlue: false,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: true,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/examples/rectangle_r1.png",
    thumbnail: "images/examples/rectangle_r1.png",
    itemType: "rectangle",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: true,
      isGreen: false,
      isBlue: false,
      isRotated: false,
      isThin: true,
      hasEveryRightAngles: true,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/examples/rectangle_r2.png",
    thumbnail: "images/examples/rectangle_r2.png",
    itemType: "rectangle",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: true,
      isGreen: false,
      isBlue: false,
      isRotated: true,
      isThin: false,
      hasEveryRightAngles: true,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/examples/rhombus_b1.png",
    thumbnail: "images/examples/rhombus_b1.png",
    itemType: "rhombus",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: true,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: false,
      isBlue: true,
      isRotated: true,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/examples/rhombus_r1.png",
    thumbnail: "images/examples/rhombus_r1.png",
    itemType: "rhombus",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: true,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: true,
      isGreen: false,
      isBlue: false,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/examples/square_b1.png",
    thumbnail: "images/examples/square_b1.png",
    itemType: "square",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: true,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: false,
      isBlue: true,
      isRotated: true,
      isThin: false,
      hasEveryRightAngles: true,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/examples/square_g1.png",
    thumbnail: "images/examples/square_g1.png",
    itemType: "square",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: true,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: true,
      isBlue: false,
      isRotated: true,
      isThin: false,
      hasEveryRightAngles: true,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/examples/square_g2.png",
    thumbnail: "images/examples/square_g2.png",
    itemType: "square",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: true,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: true,
      isBlue: false,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: true,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/examples/square_r1.png",
    thumbnail: "images/examples/square_r1.png",
    itemType: "square",
    valid: true,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: true,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: true,
      isGreen: false,
      isBlue: false,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: true,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/counter_examples/antiparallelogram_b1.png",
    thumbnail: "images/counter_examples/antiparallelogram_b1.png",
    itemType: "antiparallelogram",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: false,
      isRed: false,
      isGreen: false,
      isBlue: true,
      isRotated: true,
      isThin: true,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/counter_examples/antiparallelogram_r1.png",
    thumbnail: "images/counter_examples/antiparallelogram_r1.png",
    itemType: "antiparallelogram",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: false,
      isRed: true,
      isGreen: false,
      isBlue: false,
      isRotated: true,
      isThin: true,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/counter_examples/hexagon_g1.png",
    thumbnail: "images/counter_examples/hexagon_g1.png",
    itemType: "hexagon",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: false,
      hasFiveEdges: false,
      hasSixEdges: true,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: false,
      hasSameLengthOnePairOppositeEdges: false,
      hasEveryPairOppositeEdgesParallel: true,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: true,
      isBlue: false,
      isRotated: false,
      isThin: true,
      hasEveryRightAngles: true,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/counter_examples/pentagonreg_b1.png",
    thumbnail: "images/counter_examples/pentagonreg_b1.png",
    itemType: "regular_pentagon",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: false,
      hasFiveEdges: true,
      hasSixEdges: false,
      hasSameLengthEdges: true,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: false,
      isRed: false,
      isGreen: false,
      isBlue: true,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/counter_examples/pentagonreg_r1.png",
    thumbnail: "images/counter_examples/pentagonreg_r1.png",
    itemType: "regular_pentagon",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: false,
      hasFiveEdges: true,
      hasSixEdges: false,
      hasSameLengthEdges: true,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: false,
      isRed: true,
      isGreen: false,
      isBlue: false,
      isRotated: true,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/counter_examples/quadrilateral_b1.png",
    thumbnail: "images/counter_examples/quadrilateral_b1.png",
    itemType: "quadrilateral",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: false,
      hasSameLengthOnePairOppositeEdges: false,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: false,
      isRed: false,
      isGreen: false,
      isBlue: true,
      isRotated: true,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/counter_examples/quadrilateral_b2.png",
    thumbnail: "images/counter_examples/quadrilateral_b2.png",
    itemType: "quadrilateral",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: false,
      hasSameLengthOnePairOppositeEdges: false,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: false,
      isRed: false,
      isGreen: false,
      isBlue: true,
      isRotated: false,
      isThin: true,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/counter_examples/quadrilateral_g1.png",
    thumbnail: "images/counter_examples/quadrilateral_g1.png",
    itemType: "quadrilateral",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: false,
      hasSameLengthOnePairOppositeEdges: false,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: false,
      isRed: false,
      isGreen: true,
      isBlue: false,
      isRotated: true,
      isThin: true,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/counter_examples/quadrilateral_r1.png",
    thumbnail: "images/counter_examples/quadrilateral_r1.png",
    itemType: "quadrilateral",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: false,
      hasSameLengthOnePairOppositeEdges: false,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: false,
      isRed: true,
      isGreen: false,
      isBlue: false,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/counter_examples/trapezoid_g1.png",
    thumbnail: "images/counter_examples/trapezoid_g1.png",
    itemType: "trapezoid",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: false,
      hasSameLengthOnePairOppositeEdges: false,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: true,
      isBlue: false,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: true
    }
  },
  {
    src: "images/counter_examples/trapezoidiso_b1.png",
    thumbnail: "images/counter_examples/trapezoidiso_b1.png",
    itemType: "isoscele_trapezoid",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: false,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: false,
      isBlue: true,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/counter_examples/trapezoidiso_g1.png",
    thumbnail: "images/counter_examples/trapezoidiso_g1.png",
    itemType: "isoscele_trapezoid",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: false,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: true,
      isBlue: false,
      isRotated: false,
      isThin: true,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/counter_examples/trapezoidiso_g2.png",
    thumbnail: "images/counter_examples/trapezoidiso_g2.png",
    itemType: "isoscele_trapezoid",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: false,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: false,
      isGreen: true,
      isBlue: false,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/counter_examples/trapezoidiso_r1.png",
    thumbnail: "images/counter_examples/trapezoidiso_r1.png",
    itemType: "isoscele_trapezoid",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: false,
      hasFourEdges: true,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: false,
      hasSameLengthEveryPairOppositeEdges: false,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: true,
      isRed: true,
      isGreen: false,
      isBlue: false,
      isRotated: true,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/counter_examples/triangleequi_b1.png",
    thumbnail: "images/counter_examples/triangleequi_b1.png",
    itemType: "equilateral_triangle",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: true,
      hasFourEdges: false,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: true,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: false,
      isRed: false,
      isGreen: false,
      isBlue: true,
      isRotated: false,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  },
  {
    src: "images/counter_examples/triangleequi_g1.png",
    thumbnail: "images/counter_examples/triangleequi_g1.png",
    itemType: "equilateral_triangle",
    valid: false,
    shapeFeatures: {
      hasThreeEdges: true,
      hasFourEdges: false,
      hasFiveEdges: false,
      hasSixEdges: false,
      hasSameLengthEdges: true,
      hasSameLengthEveryPairOppositeEdges: true,
      hasSameLengthOnePairOppositeEdges: true,
      hasEveryPairOppositeEdgesParallel: false,
      hasAtLeastOnePairOppositeEdgesParallel: false,
      isRed: false,
      isGreen: true,
      isBlue: false,
      isRotated: true,
      isThin: false,
      hasEveryRightAngles: false,
      hasAtLeastOneRightAngle: false
    }
  }
]
  .sort(() => 0.5 - Math.random())
  .map(entry => {
    entry.customOverlay = (
      <div
        style={{
          opacity: 1,
          position: "absolute",
          height: "100%",
          width: "100%",
          background:
            "linear-gradient(to bottom,rgba(0,0,0,0.26),transparent 56px,transparent)"
        }}
      />
    );
    entry.thumbnailHeight = thumbnailHeight;
    entry.thumbnailWidth = thumbnailWidth;
    return entry;
  });
/* eslint-enable no-param-reassign */

export default parallelogramData;



// WEBPACK FOOTER //
// ./src/Activity/ParallelogramData.js